import React, { useContext } from 'react'
import { Link } from 'react-router'
import styles from './ChallengeCard.scss'
import { messages as detailsMessages } from '../DetailsCard'
import { OrgContext } from 'features/organizations/OrgContext'
import { Card } from 'common/styleguide/Card'
import { DateTime } from 'common/time/DateTime'
import { Distance, Elevation } from 'common/units'
import { levelMessage } from 'lib/visibility'
import { commonNouns, commonMessages } from 'lib/localization'
import { urlWithPrivacyCode } from 'lib/utils'
import { defineMessages } from 'react-intl'

const messages = defineMessages({
  ride: {
    id: 'ChallengeCard.ride',
    defaultMessage: 'Ride {distance}',
    description: 'Ride is a verb here-- for example `Ride 1000 miles`'
  },
  climb: {
    id: 'ChallengeCard.climb',
    defaultMessage: 'Climb {elevation}',
    description: 'Climb is a verb here-- for example `Climb 10000 feet`'
  },
  participants: {
    id: 'ChallengeCard.participants',
    defaultMessage: '{count, plural, =0 {participants} one {participant} other {participants}}'
  }
})

export const ChallengeCard = ({ g, fm }) => {
  const { isCurrentClub, currentMember } = useContext(OrgContext)
  const msg = fm(levelMessage(g.visibility, true, true))
  const targetAmount = g.get('goalParams')['target_amount']

  const targetString = (goalType, targetAmount, hasTarget) => {
    if (!hasTarget) {
      return do {
        if (goalType === 'elevation_gain') { return fm(detailsMessages.mostElevation) }
        if (goalType === 'moving_time') { return fm(detailsMessages.mostTime) }
        if (goalType === 'distance') { return fm(detailsMessages.mostDistance) }
      }
    }

    return goalType === 'elevation_gain'
      ? fm(messages.climb, { elevation: <Elevation short value={targetAmount} /> })
      : fm(messages.ride, { distance: goalType === 'distance'
        ? <Distance bigUnits short value={targetAmount} />
        : `${targetAmount / 3600} ${fm(commonNouns.hours, { count: targetAmount / 3600 })}` })
  }

  return <div className={styles.challengeCard}>
    <Card noPadding>
      <Link to={isCurrentClub ? `/challenges/${g.id}/overview` : urlWithPrivacyCode(`/challenges/${g.id}`, g.privacyCode)} className={styles.link}>
        <div className={styles.cardBody}>
          <div className={styles.cardTop}>
            <img src={g.cover} className={styles.cover} />
            <img src={g.icon} className={styles.icon} />
          </div>
          <div className={styles.cardBottom}>
            <div className={styles.dates}><DateTime dateOnly medium t={g.startsOn} /> - <DateTime dateOnly medium t={g.endsOn} /></div>
            <h3 className={styles.challengeName}>
              {g.name}
            </h3>
            <div className={styles.grey}>
              {targetString(g.goalType, targetAmount, g.get('goalParams')['has_target'])}
            </div>
            <div className={styles.info}>
              <div className={styles.participants}>{g.participantsCount} {fm(messages.participants, { count: g.participantsCount })}</div>
              {currentMember
                ? <span>{msg}</span>
                : <a href={`/organizations/${g.clubId}`}>{fm(commonMessages.byline, { author: g.clubName })}</a>}
            </div>
          </div>
        </div>
      </Link>
    </Card>
  </div>
}
